import './app.scss';
import Navbar from './components/Navbar';
import { createContext, useEffect, useRef, useState } from 'react';
import Profile from './components/Profile/Profile';
import Footer from './components/Footer/Footer';
import Slider from './components/Slider/Slider';
import ContactMe from './components/ContactMe/ContactMe';
import { projects } from './Projects';

export const AppContext = createContext()

function App() {

  const [darkMode, setDarkMode] = useState(false)
  const [index, setIndex] = useState(null)
  const [data, setData] = useState([])
  const [error, setError] = useState(false)

  const hasFetchedData = useRef(false)

  useEffect(() => {
    const FetchData = async () => {
      hasFetchedData.current = true
      try {
        const res = await fetch("https://server.tautvydas.net/projects.php", {
          method: "GET" 
        })
        const p = await res.json()
        setData(p)
      } catch (error) {
        console.log("Error fetching data: ", error.message)
        setError(true)
        setData(projects)
      } finally {
        hasFetchedData.current = false
      }
    }
    if (!hasFetchedData.current) {
      FetchData()
    }
  }, [])

  const targetElement = useRef()


   const scrollToIndex = (index) => {
      const list = targetElement.current
      const listItem = list.querySelectorAll('h2')[index]
      listItem.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest"
      })
    }


  useEffect(() => {
    if (index !== null) {
      scrollToIndex(index)
    }
    setIndex(null)
  }, [index])


  return (
    <AppContext.Provider value={{ darkMode, setDarkMode, index, setIndex, data, error }}>
      <div className={`App ${darkMode ? "dark-mode" : null}`}>
        <Navbar /> 
        <div className='title big-padding'>
          <h1>{"<Web developer />"}</h1>
        </div>
        <div className='menu-items' ref={targetElement}>
          <Profile />
          <Slider />
          <ContactMe />
        </div>        
        <Footer />
      </div>
    </AppContext.Provider>
  );
}

export default App;
